// Minimal fix for collection loading errors
document.addEventListener('DOMContentLoaded', function() {
  
  // Safely check if elements exist before querying
  function safeQuerySelectorAll(selector) {
    try {
      const element = document.querySelector(selector);
      if (element) {
        return element.querySelectorAll('*');
      }
      return [];
    } catch (e) {
      console.warn('Selector error:', selector);
      return [];
    }
  }
  
  // That's it - simple and clean
});